
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as grP5tPxMp6E05axOvbIGdw_rCR00f3hRSruR3dTyi9GkMeta } from "/codebuild/output/src3862998312/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexVQCW0aC4Oyd8nWrJnQQUKDrxrGjMzPG_OwDcUxcov1sMeta } from "/codebuild/output/src3862998312/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchOwAbOVDocjyAlxHnec4T3hlkH8b_45eyzJmkeNyCrOLY4Meta } from "/codebuild/output/src3862998312/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexXAT_wz_45QWbBs2eJ9LUufGNSFXtHrEKPtp2pZnhp2W_MMeta } from "/codebuild/output/src3862998312/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93T1a3O3_JLcU5ka23AA6whCTWbLSz3nPbjya7Ft4DJqoMeta } from "/codebuild/output/src3862998312/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexxTzA9HRPvm0x7pI0nN4ST2cNjSRlXU9KzCX2VN37SpUMeta } from "/codebuild/output/src3862998312/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_931sF5FjFdbLBquk9RVXC2vqimcVjKk7bqFy8_JuMwm_45cMeta } from "/codebuild/output/src3862998312/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as index6bJMBrnwbQIZLPOnS6_453QVuKx_BuJtYWgBUZzU3eNBQMeta } from "/codebuild/output/src3862998312/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93WRcP1k_45_UXsK4QV0StQV_L7efZZS_EljVT4U4ssi_451sMeta } from "/codebuild/output/src3862998312/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexbvHPxLj6rQAFzK4bO1a5aNiulMAN5pBoUtxtOksml_458Meta } from "/codebuild/output/src3862998312/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexu2XWVVBMcWIvrcywG__45uvCFcdzdbtRG7XkdfsK9OAyMMeta } from "/codebuild/output/src3862998312/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3862998312/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3862998312/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3862998312/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3862998312/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3862998312/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexxTzA9HRPvm0x7pI0nN4ST2cNjSRlXU9KzCX2VN37SpUMeta || {},
    component: () => import("/codebuild/output/src3862998312/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3862998312/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: index6bJMBrnwbQIZLPOnS6_453QVuKx_BuJtYWgBUZzU3eNBQMeta || {},
    component: () => import("/codebuild/output/src3862998312/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3862998312/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexbvHPxLj6rQAFzK4bO1a5aNiulMAN5pBoUtxtOksml_458Meta || {},
    component: () => import("/codebuild/output/src3862998312/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexu2XWVVBMcWIvrcywG__45uvCFcdzdbtRG7XkdfsK9OAyMMeta || {},
    component: () => import("/codebuild/output/src3862998312/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]